import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { Tabulation } from '../models/tabulation.model';

@Injectable({ providedIn: 'root' })
export class TabulationService extends AbstractService<Tabulation> {

  getURLBase(): string {
    return '/tabulation';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Tabulation): void {
    delete obj?._id;
  }

  preUpdate(obj: Tabulation): void {
  }

}
